import React, { useMemo } from 'react';
import { useListContext, useTranslate } from 'react-admin';
import DownloadIcon from '@material-ui/icons/GetApp';
import { Box, Button } from '@material-ui/core';
import { hasPermission } from '../../../../services/util/auth';
import resourceSlug from '../../../../constant/resource-slug';
import { getQueryUrl } from '../../../../services/provider/dataProvider';
import { useNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';

const PaymentListActions = (props) => {
  const t = useTranslate();

  const { filter, filterValues, currentSort, error } = useListContext(props);

  const data = useNoPageListData(resourceSlug.PAYMENT);

  const queryString = useMemo(() => {
    const { query: queryString } = getQueryUrl(resourceSlug.PAYMENT, {
      sort: currentSort,
      filter: filter
        ? {
            ...filterValues,
            ...filter,
          }
        : filterValues,
    });

    return queryString;
  }, [filter, filterValues, currentSort]);

  return (
    <>
      {hasPermission(resourceSlug.PAYMENT, 'export') && (
        <Button
          color="primary"
          variant="text"
          size="small"
          href={`api/${resourceSlug.PAYMENT}/export?${queryString}`}
          disabled={data?.length === 0 || !!error}
          startIcon={<DownloadIcon />}
        >
          <Box fontSize={12}>{t('ra.action.export')}</Box>
        </Button>
      )}
    </>
  );
};

export default PaymentListActions;
